function fmt(n) {
  if (n == null || n === 0) return '–'
  if (n >= 1e9) return `$${(n / 1e9).toFixed(1)}B`
  if (n >= 1e6) return `$${(n / 1e6).toFixed(1)}M`
  return `$${(n / 1e3).toFixed(0)}K`
}

const TYPE_STYLE = {
  acquisition: { color: '#3B82F6', bg: 'rgba(59,130,246,0.12)', border: 'rgba(59,130,246,0.3)' },
  development: { color: '#2ECC71', bg: 'rgba(46,204,113,0.12)', border: 'rgba(46,204,113,0.3)' },
  lending:     { color: '#D4AF37', bg: 'rgba(212,175,55,0.12)', border: 'rgba(212,175,55,0.3)' },
}

export default function StatsPanel({ deals, filteredDeals }) {
  const total    = filteredDeals.length
  const noCoords = filteredDeals.filter(d => !d.lat).length
  const totalVal = filteredDeals.reduce((s, d) => s + (d.value || 0), 0)

  const byType = { acquisition: 0, development: 0, lending: 0 }
  for (const d of filteredDeals) {
    if (byType[d.type] != null) byType[d.type]++
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      {Object.entries(byType).map(([type, count]) => {
        const s = TYPE_STYLE[type]
        return (
          <div key={type} style={{
            display: 'flex', alignItems: 'center', gap: 6,
            padding: '4px 10px',
            background: s.bg,
            border: `1px solid ${s.border}`,
            borderRadius: 20,
          }}>
            <div style={{ width: 6, height: 6, borderRadius: '50%', background: s.color }} />
            <span style={{ fontSize: 10, color: '#94A3B8', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
              {type.slice(0, 3)}
            </span>
            <span style={{ fontSize: 12, fontWeight: 700, color: '#FFFFFF' }}>
              {count.toLocaleString()}
            </span>
          </div>
        )
      })}

      <div style={{
        padding: '4px 10px',
        borderLeft: '1px solid rgba(255,255,255,0.08)',
        marginLeft: 4,
      }}>
        <span style={{ fontSize: 11, color: '#94A3B8' }}>Pipeline </span>
        <span style={{ fontSize: 12, fontWeight: 700, color: '#D4AF37' }}>{fmt(totalVal)}</span>
      </div>

      {noCoords > 0 && (
        <span style={{ fontSize: 10, color: '#94A3B8', opacity: 0.6 }}>
          · {noCoords} no coords
        </span>
      )}
    </div>
  )
}
